module.exports = __webpack_public_path__ + "static/media/total_list.fb01328c.svg";